// validators.js
export const priceReg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/; // 两位小数金额
export const positiveIntegerReg = /^[0-9]*[1-9][0-9]*$/; //正整数
export const phoneReg = /^1[3456789]\d{9}$/; //手机号
export const idCardReg = /^[0-9X]*$/; //简单身份证数字+X
export const accountReg = /^[a-zA-Z0-9]{6,16}$/; // 长度6~16位，数字或英文字母
export const llreg = /^(?!0$)([1-9]|1\d|2[0-3]|24(\.0{1,2})?|\d\.\d{1,2})$/; // 年利率 大于0小于等于24% 2位小数
// 邮箱正则
export const emailReg =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const nameReg = /^[\u4e00-\u9fffa-zA-Z]{2,15}$/;
export const ratioReg = /^(?!0\d)\d{1,2}(?:\.\d{1,2})?$|^100(?:\.0{1,2})?$/;
export const ratio2Reg = /^-?0(\.\d{1,5})?$/;
// export const rate1Reg = /^0\.(?:0[1-9]|1[0-5])$/; // 0.01-0.15之间的数字
export const rate1Reg = /^(?:0\.(?:0[1-9]|1[0-5])|0\.1)$/; // 0.01-0.15之间的数字
export const regex = /^[a-zA-Z]+$/; // 全中文
export const rate3Reg = /^(?!0\d)\d{1,2}(?:\.\d{1,2})?$|^15(?:\.0{1,2})?$/;
export const rateNumber = /^\d{6}$/;
export const rateNumber8 = /^\d{8}$/;

export function validateEn(rule, value, callback) {
  if (!value) {
    callback();
  }
  if (!regex.test(value)) {
    return callback(new Error("请正确英文"));
  } else {
    callback();
  }
}
export function validateNumber(rule, value, callback) {
  if (!value) {
    callback();
  }
  if (!rateNumber.test(value)) {
    return callback(new Error("请输入6位纯数字密码"));
  } else {
    callback();
  }
}
export function validateNumber8(rule, value, callback) {
  if (!value) {
    callback();
  }
  if (!rateNumber8.test(value)) {
    return callback(new Error("请输入8位纯数字"));
  } else {
    callback();
  }
}
export function validatePrice(rule, value, callback) {
  if (!value) {
    callback();
  }
  if (!priceReg.test(value)) {
    return callback(new Error("请正确输入，保留两位小数"));
  } else {
    callback();
  }
}
export function validateRate1(rule, value, callback) {
  if (!value) {
    callback();
  }
  if (!rate1Reg.test(value)) {
    return callback(new Error("请输入0.01-0.15内的数字"));
  } else {
    callback();
  }
}
export function validateRate3(rule, value, callback) {
  if (!value) {
    callback();
  }
  if (!rate3Reg.test(value)) {
    return callback(new Error("请输入0-15内的数字,最多两位小数"));
  } else {
    callback();
  }
}
// 比例
export function validateRatio(rule, value, callback) {
  if (!value) {
    callback();
  }
  if (!ratioReg.test(value)) {
    return callback(new Error("请输入0-100并且最多两位小数的数值"));
  } else {
    callback();
  }
}
export function validateZheng(rule, value, callback) {
  // if (!value) {
  //   callback();
  // }
  if (Number(value) <= 0) {
    return callback(new Error("请输入大于零的正数"));
  } else {
    callback();
  }
}
export function validateName(rule, value, callback) {
  if (!value) {
    callback();
  }
  if (!nameReg.test(value)) {
    return callback(new Error("请输入2-15字符的中文或字母"));
  } else {
    callback();
  }
}
export function validateTwo(rule, value, callback) {
  if (!value) {
    callback();
  }
  if (!llreg.test(value)) {
    return callback(new Error("请输入大于0小于等于24的数字，最多两位小数"));
  } else {
    callback();
  }
}
// 正整数验证
export function validatePositiveInteger(rule, value, callback) {
  if (!value) {
    callback();
  }
  if (!positiveIntegerReg.test(value)) {
    return callback(new Error("请正确输入正整数"));
  } else {
    callback();
  }
}

// 手机号
export function validatePhone(rule, value, callback) {
  if (!value) {
    callback();
  }
  if (!phoneReg.test(value)) {
    return callback(new Error("请输入正确手机号"));
  } else {
    callback();
  }
}

// 身份证验证
export function validateIdCard(rule, value, callback) {
  if (!value) {
    callback();
  }
  if (!idCardReg.test(value)) {
    return callback(new Error("请输入18位数字或字母"));
  } else {
    callback();
  }
}

// 邮箱验证
export function validateIdEmail(rule, value, callback) {
  if (!value) {
    callback();
  }
  if (!emailReg.test(value)) {
    return callback(new Error("请正确输入邮箱"));
  } else {
    callback();
  }
}

// 长度6~16位，数字或英文字母
export function validateIdAccount(rule, value, callback) {
  if (!value) {
    callback();
  }
  if (!accountReg.test(value)) {
    return callback(new Error("请输入长度6~16位，数字或英文字母"));
  } else {
    callback();
  }
}
